import { eftPath } from "@cle/constants/routes";

type EvidenceDocumentTypeInfo = {
  label: string;
  pathSegment: string;
};

/**
 * Maps a reportable evidence type (as returned by the CLE reporting API,
 * snake_case) to its Danish label and its document-detail route segment.
 *
 * The camelCase aliases are kept for defensiveness/legacy callers; the backend
 * emits snake_case (see cle-compliance-api EvidenceType enum). The path segments
 * must match the routes registered in `routes.tsx`.
 */
const EVIDENCE_DOCUMENT_TYPES: Record<string, EvidenceDocumentTypeInfo> = {
  course_certificate: { label: "Kursusbevis", pathSegment: "kursusbevis" },
  courseCertificate: { label: "Kursusbevis", pathSegment: "kursusbevis" },
  teaching: { label: "Undervisning", pathSegment: "undervisning" },
  reduction: { label: "Reduktion", pathSegment: "reduktion" },
  authorship: { label: "Forfatterskab", pathSegment: "forfatterskab" },
  dispensation: { label: "Dispensation", pathSegment: "dispensation" },
  legal_aid: {
    label: "Advokatvagt/retshjælp",
    pathSegment: "advokatvagt-retshjaelp",
  },
  legalAid: {
    label: "Advokatvagt/retshjælp",
    pathSegment: "advokatvagt-retshjaelp",
  },
};

export const getEvidenceTypeLabel = (evidenceType: string): string =>
  EVIDENCE_DOCUMENT_TYPES[evidenceType]?.label ?? evidenceType;

export const getEvidenceDocumentPath = (
  evidenceType: string,
  id: string,
): string | null => {
  const pathSegment = EVIDENCE_DOCUMENT_TYPES[evidenceType]?.pathSegment;

  return pathSegment ? eftPath(`dokumenter/${pathSegment}/${id}`) : null;
};
